import styled from "styled-components";

export const Page = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 260px;
  height: 138px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.secondary10};
  border-radius: 8px;
  padding: 20px;
  
  .info {
    display: flex;
    flex: 60%;
    flex-direction: column;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary100};
    span {
      color: ${({ theme }) => theme.colors.secondary70};
    }
  }
  .single-chart {
    flex: 40%;
    .circular-chart {
      display: block;
      margin: 10px auto;
      max-width: 100%;
      max-height: 350px;
      justify-content: space-around;
      .percentage {
        color: ${({ theme }) => theme.colors.secondary100};
        fill: ${({ theme }) => theme.colors.secondary100};
        font-family: sans-serif;
        font-size: 0.7em;
        text-anchor: middle;
        font-weight: 600;
        stroke: none;
      }
    }

    .green {
      stroke: ${({ theme }) => theme.colors.primary};
    }
    .circle-bg {
      fill: none;
      stroke: rgba(0, 191, 165, 0.5);
      stroke-width: 4.2;
    }

    .circle {
      fill: none;
      stroke-width: 3.5;
      stroke-linecap: round;
      animation: progress 1s ease-out forwards;
    }
    @keyframes progress {
      0% {
        stroke-dasharray: 0 100;
      }
    }
  }
`;
